// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZVp6W","clinicsSelect":"styles_clinicsSelect__1KK1m"};